import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { FaPencilAlt, FaTrash, FaPlus } from 'react-icons/fa';
import { apiURL } from '../../config';
import Footer from 'components/Footers/Footer';

const SalaryManagement = () => {
    const [salaryComponents, setSalaryComponents] = useState([]);
    const [newComponentName, setNewComponentName] = useState('');
    const [newComponentType, setNewComponentType] = useState('allowance');
    const [newComponentValue, setNewComponentValue] = useState('');
    const [editComponentId, setEditComponentId] = useState(null);
    const [editComponentName, setEditComponentName] = useState('');
    const [editComponentType, setEditComponentType] = useState('allowance');
    const [editComponentValue, setEditComponentValue] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteComponentId, setDeleteComponentId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;
    const baseURL = apiURL;
    const token = localStorage.getItem("token");


    useEffect(() => {
        fetchSalaryComponents();
    }, [currentPage]);

    const fetchSalaryComponents = async () => {
        try {
            const response = await fetch(`${baseURL}/superadmin/salary/components?page=${currentPage}&limit=${itemsPerPage}`, {
                method: 'GET', // or any other HTTP method as needed
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                },
            });
            const data = await response.json();
            if (data && data.salaryComponents && Array.isArray(data.salaryComponents)) {
                setSalaryComponents(data.salaryComponents);
                setTotalPages(data.totalPages);
            } else {
                setSalaryComponents([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching salary components:', error);
            toast.error('Error fetching salary components!');
        }
    };

    const handleAddSalaryComponent = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseURL}/superadmin/salary/components`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({
                    name: newComponentName,
                    type: newComponentType,
                    value: newComponentValue,
                }),
            });
            if (response.ok) {
                toast.success('Salary component added successfully!');
                fetchSalaryComponents();
                setNewComponentName('');
                setNewComponentType('allowance');
                setNewComponentValue('');
                setModalOpen(false);
            } else {
                toast.error('Error adding salary component!');
            }
        } catch (error) {
            console.error('Error adding salary component:', error);
            toast.error('Error adding salary component!');
        }
    };

    const handleEditSalaryComponent = (component) => {
        setEditComponentId(component._id);
        setEditComponentName(component.name);
        setEditComponentType(component.type);
        setEditComponentValue(component.value);
        setEditModalOpen(true);
    };

    const handleUpdateSalaryComponent = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseURL}/superadmin/salary/components/${editComponentId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({
                    name: editComponentName,
                    type: editComponentType,
                    value: editComponentValue,
                }),
            });
            if (response.ok) {
                toast.success('Salary component updated successfully!');
                fetchSalaryComponents();
                setEditComponentId(null);
                setEditComponentName('');
                setEditComponentType('allowance');
                setEditComponentValue('');
                setEditModalOpen(false);
            } else {
                toast.error('Error updating salary component!');
            }
        } catch (error) {
            console.error('Error updating salary component:', error);
            toast.error('Error updating salary component!');
        }
    };

    const handleDeleteSalaryComponent = (id) => {
        setDeleteComponentId(id);
        setDeleteModalOpen(true);
    };

    const confirmDeleteSalaryComponent = async () => {
        try {
            const response = await fetch(`${baseURL}/superadmin/salary/components/${deleteComponentId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
            });
            if (response.ok) {
                toast.success('Salary component deleted successfully!');
                fetchSalaryComponents();
            } else {
                toast.error('Error deleting salary component!');
            }
        } catch (error) {
            console.error('Error deleting salary component:', error);
            toast.error('Error deleting salary component!');
        } finally {
            setDeleteModalOpen(false);
            setDeleteComponentId(null);
        }
    };

    const filteredSalaryComponents = salaryComponents ? salaryComponents.filter((component) =>
        component.name.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const renderPagination = () => {
        const paginationItems = [];
        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <PaginationItem key={i} active={i === currentPage}>
                    <PaginationLink onClick={() => handlePageChange(i)}>
                        {i}
                    </PaginationLink>
                </PaginationItem>
            );
        }
        return (
            <Pagination>
                {paginationItems}
            </Pagination>
        );
    };

    const getTypeColor = (type) => {
        switch (type) {
            case 'allowance':
                return 'text-success';
            case 'bonus':
                return 'text-danger';
            case 'deduction':
                return 'text-warning';
            default:
                return '';
        }
    };

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">Salary Management</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage salary components for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Salary Components</h3>
                                <div>
                                    <Input
                                        type="text"
                                        placeholder="Search salary components..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ marginRight: '10px', display: 'inline-block', width: '200px' }}
                                    />
                                    <Button color="primary" onClick={() => setModalOpen(true)}>
                                        <FaPlus /> Add New
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>Value</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredSalaryComponents && filteredSalaryComponents.length > 0 ? (
                                            filteredSalaryComponents.map((component) => (
                                                <tr key={component._id}>
                                                    <td>{component.name}</td>
                                                    <td className={getTypeColor(component.type)}>{(component.type).toUpperCase()}</td>
                                                    <td>{component.value}</td>
                                                    <td>
                                                        <>
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() => handleEditSalaryComponent(component)}
                                                            >
                                                                <FaPencilAlt />
                                                            </Button>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteSalaryComponent(component._id)}
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">No salary components found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                                {totalPages > 1 && renderPagination()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add New Salary Component</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddSalaryComponent}>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter component name"
                                value={newComponentName}
                                onChange={(e) => setNewComponentName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input
                                type="select"
                                value={newComponentType}
                                onChange={(e) => setNewComponentType(e.target.value)}
                            >
                                <option value="allowance">Allowance</option>
                                <option value="deduction">Deduction</option>
                                <option value="bonus">Bonus</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Value</Label>
                            <Input
                                type="number"
                                placeholder="Enter component value"
                                value={newComponentValue}
                                onChange={(e) => setNewComponentValue(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Salary Component
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Salary Component</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateSalaryComponent}>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter component name"
                                value={editComponentName}
                                onChange={(e) => setEditComponentName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input
                                type="select"
                                value={editComponentType}
                                onChange={(e) => setEditComponentType(e.target.value)}
                            >
                                <option value="allowance">Allowance</option>
                                <option value="deduction">Deduction</option>
                                <option value="bonus">Bonus</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Value</Label>
                            <Input
                                type="number"
                                placeholder="Enter component value"
                                value={editComponentValue}
                                onChange={(e) => setEditComponentValue(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Salary Component
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>Delete Salary Component</ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this salary component?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteSalaryComponent}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
             <Footer />
        </>
    );
};

export default SalaryManagement;
